import React from 'react';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { messages } from './common/Translations';

import {
    Modal as BootstrapModal,
    ModalHeader,
    ModalTitle,
    ModalClose,
    ModalBody,
    ModalFooter
} from 'react-modal-bootstrap';

const Modal = ({ isOpen, close, confirm, closeText, confirmText, title, children, intl }) => {

    const renderConfirmBtn = function() {
        if (confirm) {
            return (
                <button
                    type='button'
                    className={classNames(['btn', 'btn-success', 'clickable', 'modal-no'])}
                    onClick={confirm}
                >
                    {confirmText || 'OK'}
                </button>
            );
        }
    };

    return (
        <BootstrapModal
            isOpen={isOpen}
        >
            <ModalHeader>
                <ModalTitle>{title}</ModalTitle>
                <ModalClose onClick={close} />
            </ModalHeader>
            <ModalBody>
                {children}
            </ModalBody>
            <ModalFooter>
                {renderConfirmBtn()}
                <button
                    type='button'
                    className={classNames(['btn', 'btn-info', 'clickable', 'modal-no'])}
                    onClick={close}
                >
                    {closeText || intl.formatMessage(messages.closeModal)}
                </button>
            </ModalFooter>
        </BootstrapModal>
    );
};

export default injectIntl(Modal);


// WEBPACK FOOTER //
// ./web/src/components/Modal.jsx